import { Component, OnDestroy, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { untilDestroyed } from 'ngx-take-until-destroy';

@Component({
  selector: 'app-pass-key-delete-success',
  templateUrl: './pass-key-delete-success.component.html',
  styleUrl: './pass-key-delete-success.component.scss',
  standalone: false
})
export class PassKeyDeleteSuccessComponent implements OnInit, OnDestroy {

  userEmail: string;
  onCloseLinkSubmit: () => void;
  language: any;
  iosLink: string;
  andriodLink: string;
  chromeLink: string;
  edgeLink:string;
  safariLink: string;

  constructor(private readonly translate: TranslateService,
              private readonly cookieService: CookieService
  ) { }

  ngOnInit(): void {
    this.getLinks();

    this.translate.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((langEvent: LangChangeEvent) => {
        this.language = langEvent.lang;
        this.getLinks();
    });
  }

  onCloseClick(){
    this.onCloseLinkSubmit();
  }

  ngOnDestroy(): void {}

  getLinks(){
    this.language = this.cookieService.get('lang');

    this.iosLink = this.language === 'en' 
    ? 'https://support.apple.com/en-ca/guide/iphone/iphf538ea8d0/ios' 
    : 'https://support.apple.com/fr-ca/guide/iphone/iphf538ea8d0/ios';

    this.andriodLink = this.language === 'en' 
    ? 'https://support.google.com/accounts/answer/13548313?hl=en&sjid=6867787736020816167-NC#zippy=%2Cmissing-or-unavailable-passkey' 
    : 'https://support.google.com/accounts/answer/13548313?hl=fr&sjid=636958103724464611-NC';

    this.chromeLink = this.language === 'en' 
    ? 'https://support.google.com/chrome/answer/13168025?hl=en&co=GENIE.Platform%3DDesktop' 
    : 'https://support.google.com/chrome/answer/13168025?hl=fr&co=GENIE.Platform%3DDesktop&sjid=636958103724464611-NC';

    this.edgeLink = this.language === 'en' 
    ? 'https://support.microsoft.com/en-us/account-billing/create-and-save-a-passkey-e92cd3e0-11fa-4630-a5ea-3ccc0396b3d9' 
    : 'https://support.microsoft.com/fr-fr/account-billing/cr%C3%A9er-et-enregistrer-une-cl%C3%A9-d-acc%C3%A8s-e92cd3e0-11fa-4630-a5ea-3ccc0396b3d9';

    this.safariLink = this.language === 'en' 
    ? 'https://support.apple.com/en-ca/guide/iphone/iph37306ae67/ios' 
    : 'https://support.apple.com/fr-ca/guide/iphone/iph37306ae67/ios';
  }

}
